import { Loader2, AlertTriangle, RefreshCw, Inbox } from 'lucide-react'
import { useTranslation } from 'react-i18next'

// Carregando, erro e vazio são três estados diferentes e precisam parecer diferentes:
// com o backend fora, uma tela vazia dizendo "nenhum registro" convida o despachante a
// cadastrar o que já existe. Estes três blocos são a forma única de renderizá-los.

export function LoadingState({ label, className = 'h-64' }) {
  const { t } = useTranslation()
  return (
    <div className={`flex items-center justify-center gap-2 text-slate-400 dark:text-slate-500 ${className}`}>
      <Loader2 size={20} className="animate-spin" />
      <span className="text-sm">{label || t('common:states.loading')}</span>
    </div>
  )
}

export function ErrorState({ message, onRetry, className = 'h-64' }) {
  const { t } = useTranslation()
  return (
    <div className={`flex flex-col items-center justify-center text-center px-4 ${className}`}>
      <AlertTriangle size={36} className="mb-3 text-status-down" />
      <p className="text-sm font-medium text-slate-700 dark:text-slate-200">{t('common:states.error')}</p>
      {message && <p className="mt-1 text-xs text-slate-500 dark:text-slate-400 max-w-md break-words">{message}</p>}
      {onRetry && (
        <button onClick={onRetry}
          className="mt-3 inline-flex items-center gap-1.5 px-3 py-1.5 text-sm text-slate-600 dark:text-slate-300 border border-slate-200 dark:border-slate-700 rounded-lg hover:bg-slate-50 dark:hover:bg-slate-800">
          <RefreshCw size={14} /> {t('common:actions.retry')}
        </button>
      )}
    </div>
  )
}

export function EmptyState({ icon: Icon = Inbox, message, hint, className = 'h-64' }) {
  const { t } = useTranslation()
  return (
    <div className={`flex flex-col items-center justify-center text-center text-slate-400 dark:text-slate-500 px-4 ${className}`}>
      <Icon size={36} className="mb-3 text-slate-300 dark:text-slate-600" />
      <p className="text-sm">{message || t('common:states.empty')}</p>
      {hint && <p className="mt-1 text-xs">{hint}</p>}
    </div>
  )
}

// Atalho para o caso comum: decide entre os três e só renderiza o conteúdo quando há dado.
export default function ViewState({ loading, error, empty, onRetry, emptyIcon, emptyMessage, emptyHint, loadingLabel, className, children }) {
  if (loading) return <LoadingState label={loadingLabel} className={className} />
  if (error) return <ErrorState message={typeof error === 'string' ? error : error?.message} onRetry={onRetry} className={className} />
  if (empty) return <EmptyState icon={emptyIcon} message={emptyMessage} hint={emptyHint} className={className} />
  return children
}
